import Socket from 'socket.io-client'
import actions from '../actions'
import DataProcessor from '../dataProcessor';
import EventEmitter from '../../helpers/eventEmitter';

let socket = null
const socketUrl = new URL(window.config.proxySocketUrl)
const localState = {
  connected: false,
  subs: {},
  __sync_id: {},
}
const subEmitters = {}

const getSocket = (access_token) => {
  if (!socket) {
    socket = Socket(socketUrl.origin, {
      'query': {access_token},
      'path': socketUrl.pathname,
      'transports': ['websocket'],
      // 'timeout': 10000,
      'reconnection': true,
      'reconnectionDelay': 500,
      'reconnectionDelayMax': 5000,
      'reconnectionAttempts': Infinity,
    })
  }
  return socket
}

const setupSocket = (store, access_token) => {
  const socket = window.socketWatcher = getSocket(access_token)

  const handleNotification = (data) => {
    const {name: collection, action} = data
    console.log('Receive notification -> ', _.cloneDeep(data));

    console.log('subscription SYNC_ID', collection, '>>', localState.__sync_id[collection], '<<', data.__sync_id)
    if (localState.__sync_id[collection] !== data.__sync_id) {
      console.error('Bad SYNC_ID for collection', collection, '>>', localState.__sync_id[collection], '<<', data.__sync_id)
      return;
    }

    switch (action) {
      case 'update':
        store.dispatch(actions.STORE_ITEM_REPLACE, {collection, id: data.id, object: data.item})
        break
      case 'partial':
        store.dispatch(actions.STORE_ITEM_UPDATE, {collection, id: data.id, object: data.item})
        break
      case 'delete':
        store.dispatch(actions.STORE_ITEM_REMOVE, {collection, id: data.id})
        break
      case 'create':
        store.dispatch(actions.STORE_ITEM_CREATE, {collection, id: data.id, object: data.item})
        break
      case 'reset':
        const dataProcessor = new DataProcessor(store)
        data.items.forEach(item => {
          if (!isNaN(item._id)) {
            item.id = item._id
          }
          dataProcessor.process(collection, item)
        })

        store.dispatch(actions.STORE_BULK_INSERT_DATA, {collection, data: data.items});
        break
      default:
        console.error('actions is not handled', data)
    }
  }

  socket.on('connect_failed', () => console.error('[watcher.io] connect_failed', socket.id))
  socket.on('message', handleNotification)
  socket.on('logout', () => {
    localStorage.removeItem('token')
    store.commit('setToken', null)
  })
  socket.on('disconnect', () => {
    console.log('[watcher.io] disconnected from server', socket.id);
    localState.connected = false
  })
  socket.on('close', () => {
    console.log('[watcher.io] closed connection to', socket.id);
    localState.connected = false
  })
  socket.on('connect', () => {
    localState.connected = true
    console.info('WS Connected to ', socketUrl.href, socket.id);
    _.keys(localState.subs).forEach(key => subscribe(localState.subs[key]))
  });

  function subscribe(payload) {
    socket.emit('subscribe', payload, (res) => subEmitters[payload.collection] && subEmitters[payload.collection].emit('result', res))
  }

  window.restartReactivity = function() {
    socket.emit('restart_reactivity');
  };

  const subscriptionCache = {};
  const skipCachingList = ['device_hardware']

  window.socketWatcherResubscribe = () => {
    _.keys(localState.subs).forEach(key => subscribe(localState.subs[key]));
  }

  window.socketWatcherSubscribe = (payload) => new Promise((resolve, reject) => {
    if (subscriptionCache[payload.collection] === JSON.stringify(payload)) return resolve();
    if (!_.includes(skipCachingList, payload.collection)) subscriptionCache[payload.collection] = JSON.stringify(payload);
    localState.__sync_id[payload.collection] = +Date.now()
    payload.__sync_id = localState.__sync_id[payload.collection]
    localState.subs[payload.collection] = payload;
    subEmitters[payload.collection] = subEmitters[payload.collection] || new EventEmitter();
    subEmitters[payload.collection].once('result', (res) => res ? resolve() : reject());
    if (!localState.connected) return;
    subscribe(payload);
  })
}

export default (store) => {
  store.subscribe((mutation, state) => {
    if (mutation.type === 'setToken') {
      const access_token = mutation.payload

      socket && socket.disconnect()
      socket = null

      if (access_token) {
        setupSocket(store, access_token)
      }

    }
  })
}



// WEBPACK FOOTER //
// ./src/store/plugins/watcherSocketPlugin.js